import { BranchModuleDeclaration } from './branch/branch.declaration';
import { CustomFromDeclaration } from './custom-form/custom-form.declaration';
import { LocationPickupComponent } from './directives/location-pickup/location-pickup.component';
import { DriverComponent } from './driver/driver.component';
import { DriverModuleDeclaration } from './driver/driver.declaration';
import { EmployeeBillingComponent } from './employeebilling/employeebilling.component';
import { EmpoloyeeBillingDeclatation } from './employeebilling/employeebilling.declaration';
import { EmployeedetailsComponent } from './employeedetails/employeedetails.component';
import { EmployeeDetailsDeclatation } from './employeedetails/employeedetails.declaration';
import { HolidayComponent } from './holiday-pattern/holiday.component';
import { InformationDashboardComponent } from './information-dashboard/information-dashboard.component';
import { ManageVehicleDriverDeclaration } from './manage-vehicle-driver/manage-vehicle-driver.declaration';
import { NotificationsDeclaration } from './notifications/notifications.declaration';
import { TransportOrganizationDeclaration } from './organization/transport-organization.declaration';

import { EscortComponent } from './escort/escort.component';
import { EscortDetailsDeclatation } from './escort/escort.declaration';

import { ParkingModuleDeclaration } from './parking/parking.declaration';
import { PaymetHistoryComponent } from './paymenthistory/paymenthistory.componet';
import { PaymentHistoryDeclaration } from './paymenthistory/paymenthistory.declaration';
import { AddShiftComponent } from './shift/add-shift/add-shift.component';
import { EditShiftComponent } from './shift/edit-shift/edit-shift.component';
import { ListShiftComponent } from './shift/list-shift/list-shift.component';
import { SingleViewShiftComponent } from './shift/list-shift/single-view-shift';
import { ShiftDeclaration } from './shift/shfit.declaration';
import { TransportManagerAccountDeclaration } from './transport-manager-account/transport-manager-account.declaration';
import { VehicleInformationComponent } from './vehicle/vehicle.component';
import { VehicleDeclaration } from './vehicle/vehicle.declaration';
import { VendorDeclaration } from './vendor/vendor-declaration';
import { VendorComponent } from './vendor/vendor.component';

import { ExcelUploadAlertComponent } from './directives/excel-upload-alert/excel-upload-alert.component'

// users
import { UsersInformationComponent } from './users/users.component'

import { UsersDeclaration } from './users/users.declaration'


export const InformationDeclaration = [
    VehicleDeclaration,
    VendorDeclaration,
    DriverModuleDeclaration,
    /* EmployeeDetailsDeclatation,
    EmpoloyeeBillingDeclatation, */
    PaymentHistoryDeclaration,
    VendorComponent,
    DriverComponent,
    VehicleInformationComponent,
    /* EmployeedetailsComponent,
    EmployeeBillingComponent, */
    PaymetHistoryComponent,
    InformationDashboardComponent,
    // ListShiftComponent,
    // AddShiftComponent,
    // EditShiftComponent,
    // SingleViewShiftComponent,
    /* ShiftDeclaration,
    BranchModuleDeclaration,
    ParkingModuleDeclaration,
    CustomFromDeclaration,
    NotificationsDeclaration, 
    HolidayComponent, */

    TransportOrganizationDeclaration,
    LocationPickupComponent,
    ExcelUploadAlertComponent,
    TransportManagerAccountDeclaration,
    ManageVehicleDriverDeclaration,
    UsersInformationComponent,
    UsersDeclaration,

];
